export default __webpack_public_path__ + "images/qrcode-icon.png";